import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Audiencepoint() {
  return (
    <section className="scope_rev p-100 text_white bg_purple_color">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project Scope and
              <span style={{ color: "#E8E751" }}> Objectives</span>
            </h2>
            <div className="scope_content">
              <p>
                The project scope involves the development and implementation of
                Rev Coin, a crypto stock-based solution, with the key objective
                of improving employee benefits and loyalty.
              </p>
              <p>
                The scope outspreads beyond the instant implementation to
                guarantee long-term scalability and value addition for employees
                and the organization. Rev Coin offers abundant advantages that
                go past traditional loyalty programs. It not only offers
                employees with a perceptible stake in the company but also
                allows them to grow alongside the company as it grows globally.
              </p>
              <p>
                By linking Rev Coin to all TekRevol products, employees can
                inertly make income and enjoy rewards without needing prior
                investment knowledge.
              </p>
              <p>
                Furthermore, Rev Coin holders gain access to extra privileges
                and benefits within the company's environment, further
                strengthening their commitment and sense of belonging.
              </p>
              <p>
                In the long run, Rev Coin has the potential to transform the way
                employee benefits are professed and managed.
              </p>
              <p>
                The scalability of the solution permits for future integration
                with other TekRevol services and app rewards, increasing its
                impact on employee engagement and fulfilment.
              </p>
              <p>
                As the company grows, Rev Coin holders can imagine their stake
                in the company to grow, providing a valued asset for their
                individual growth and financial stability.
              </p>
              <p>
                By aligning the project objectives with TekRevol's vision, the
                goal is to fashion a robust ecosystem that make the most of the
                value of Rev Coin for employees. This includes establishing
                efficient procedures for buying, selling, and transferring Rev
                Coin, as well as applying smart contracts to guarantee secure
                and controlled transactions.
              </p>
              <p>
                The project also aims to improve transparency, accountability,
                and the complete employee experience by using blockchain
                technology.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/scope_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={830}
                height={923}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Audiencepoint;
